import { useMemo } from 'react';
import { getNumberInputValidationSchema } from '../../functions/formValidations/getNumberInputValidationSchema';

export const useNumberInputValidation = ({ min, max, optional = true }) => useMemo(() => (inputValue) => {
  const schema = getNumberInputValidationSchema({
    min: typeof min === 'number' ? { value: min } : null,
    max: typeof max === 'number' ? { value: max } : null,
    optional,
  });
  const { success, error } = schema.safeParse(inputValue);
  return { isValid: success, error };
}, [max, min, optional]);
